module.exports = __webpack_public_path__ + "854881a2a2038a4bb6d75e54f34dbee9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/flagstarplanet.svg
// module id = 38
// module chunks = 0 1